export default __webpack_public_path__ + "static/media/stage_05@2x.e3dcc409.png";